import React, { useState } from "react";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

function ToastPopup(props: any) {
  const [isOpen, setIsOpen] = useState(true);
  const close = () => {
    setIsOpen(!isOpen);
  };
  return (
    <Snackbar
      sx={{ width: "100%" }}
      autoHideDuration={5000}
      open={isOpen}
      onClose={close}
      style={{position:"initial"}}
    >
      <Alert variant="filled" severity={props.type} onClose={close} style={{width:"100%"}}>
        {props.message}
      </Alert>
    </Snackbar>
  );
}

export default ToastPopup;
